import React from 'react';
import { sanitize } from 'dompurify';
import cx from 'classnames';

import { bodyTextMarkdown } from '../../utilities/cms-helpers';

export default function TouchPointBenefits({ item, titleColor }) {
  const {
    imgBenefit,
    subtitleBenefit,
    titleBenefit,
  }  = item;

  const titleClasses = cx({
    'TouchPointBenefits-title': true,
    [`TouchPointBenefits-title--${ titleColor }`]: Boolean(titleColor),
  });

  const descriptionClasses = cx({
    'TouchPointBenefits-description': true,
    [`TouchPointBenefits-description--${ titleColor }`]: Boolean(titleColor),
  });

  const mdTitle = bodyTextMarkdown(titleBenefit);
  const mdSubTitle = bodyTextMarkdown(subtitleBenefit);

  return (
    <div className='TouchPointBenefits'>
      <div className='TouchPointBenefits-image'>
        <img
          src={ imgBenefit }
          alt=''/>
      </div>
      <div className='TouchPointBenefits-info'>
        <h4 className={ titleClasses} dangerouslySetInnerHTML={ { __html: sanitize(mdTitle) } }></h4>
        <p className={ descriptionClasses }>
          <div dangerouslySetInnerHTML={ { __html: sanitize(mdSubTitle) } }></div>
        </p>
      </div>
    </div>
  );
}